import { IncomingMessage } from 'http'
import {
  isClientDeploymentEnv,
  sanitizeBaseUrl,
  sanitizeHeaderString,
} from '@reward-platform/utils'
import { RequestInvalidException } from '@reward-platform/shared-api/exceptions'
import { getValidBasePathForHost, isAviosHostValid } from '../utils/aviosUrls'

/**
 * Retrieves host from request headers, unless a valid avios.com forwarded host exists
 */
export const getPlatformHostFromRequest = (req: IncomingMessage): string | undefined => {
  const host = sanitizeHeaderString(req.headers.host)
  const forwardedHost = sanitizeHeaderString(req.headers['x-forwarded-host'])
  if (forwardedHost && isAviosHostValid(forwardedHost)) {
    return forwardedHost
  }
  return host
}

/**
 * Retrieves base path for avios.com integration using host to determine platform type
 */
export const getPlatformBasePathFromRequest = (req: IncomingMessage): string | undefined => {
  const host = getPlatformHostFromRequest(req)
  return getValidBasePathForHost(host) || ''
}

/**
 * Retrieves base url for application using host headers
 */
export const getPlatformBaseUrlFromRequest = (
  req: IncomingMessage,
  includeBasePath = true
): string => {
  const host = getPlatformHostFromRequest(req)

  if (!host) {
    throw new RequestInvalidException({ developerMessage: 'Missing or invalid host headers' })
  }

  const basePath = (includeBasePath && getPlatformBasePathFromRequest(req)) || ''

  if (isClientDeploymentEnv('local')) {
    // use http
    const localHost = sanitizeBaseUrl(host, true)
    return localHost + basePath
  }

  const baseUrlForEnv = sanitizeBaseUrl(host)
  return baseUrlForEnv + basePath
}
